import { MainComponent } from './main.component';
import { documentRoutes } from '../features/document/document-routing.module';
import { LoginComponent } from '../login/login.component';
import { AuthGuard } from '../auth-guard.service';
import { reportRoutes } from '../features/report/report-routing.module';
import { searchRoutes } from '../features/search/search-routing.module';
import { saleTaxRoutes } from '../features/saletax/saletax-routing.module';
import { profileRoutes } from '../features/profile/profile-routing.module';
import { dashboardRoutes } from '../features/dashboard/dashboard-routing.module';
import { billingRoutes } from '../features/billing/billing-routing.module';
import { taxReportRoutes } from "../features/tax-report/tax-report-routing.module";
import { zipFileRoutes } from "../features/zip-file/zip-file-routing.module";
import { ValidateOtpComponent } from "../validate-otp/validate-otp.component";
import { taxB2PRoutes } from '../features/tax-b2p/tax-b2p-routing.module';
import { downloadRoutes } from "../features/download/download-routing.module";
import { bulktaxReportRoutes } from "../features/bulk-tax-report/bulk-tax-report-routing.module";
import { DownloadRequestThComponent } from "../features/download/download-request-th/download-request-th.component";
import { DownloadRequestIncComponent } from "../features/download/download-request-inc/download-request-inc.component";
import { emailDashboardroutes } from "../features/email-dashboard/email-dashboard-routing.module";
export var mainRoutes = [
    // for role IT, default page is /dashboard-it
    // for role Accounttant, default page is /taxReport
    // more information is in constructor of file 'dashboard-list.component.ts'
    { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
    { path: 'validate-otp', component: ValidateOtpComponent },
    { path: 'validate-otp/:msg', component: ValidateOtpComponent },
    { path: 'login/:msg', component: LoginComponent },
    { path: 'login', component: LoginComponent },
    { path: 'download-request-th', component: DownloadRequestThComponent },
    { path: 'download-request-inc', component: DownloadRequestIncComponent },
    {
        path: '',
        component: MainComponent,
        children: documentRoutes.concat(reportRoutes, searchRoutes, dashboardRoutes, billingRoutes, saleTaxRoutes, profileRoutes, bulktaxReportRoutes, taxReportRoutes, zipFileRoutes, taxB2PRoutes, downloadRoutes, emailDashboardroutes),
        canActivate: [AuthGuard]
    }
];
var MainRoutingModule = (function () {
    function MainRoutingModule() {
    }
    return MainRoutingModule;
}());
export { MainRoutingModule };



// WEBPACK FOOTER //
// /opt/app/src/app/main/main-routing.module.ts.pre-build-optimizer.js